import React, { Component } from 'react'
import './hjelp.css'

export default class Hjelp extends Component {


    componentDidMount() {

        if (this.$ref && window.location.href.includes('#rapportfil')) {
            this.$ref.scrollIntoView({
                // optional params
                behaviour: 'smooth',
                block: 'start',
                inline: 'center',
            });
        }
    }

    render() {
        return (
            <div className="listeContainer">
                <h2>Brukerdokumentasjon</h2>
                <h3>Innstillinger</h3>
                <p className="responsive-paragraf">
                    Før man begynner å bruke KOMTEK Vannmålerbytte må man gå på «Innstillinger» og
                    «Forhåndsdefinerte målere». Dette er en side der du legger inn egenskaper på de
                    forskjellige vannmålerne som benyttes i kommunen.
                </p>

                <p className="responsive-paragraf">
                    Tittelen du velger på den enkelte vannmåleren vil senere komme opp som
                    valgmuligheter når du skal skrive inn info om ny måler. Ved å gjøre dette sparer
                    du mye tid og heftelse ute i felt.
                </p>

                <h3>Instruksjonsfilm</h3>
                <div className="video-responsive">
                    <iframe
                        src="https://player.vimeo.com/video/233351622"
                        width="50%"
                        height="50%"
                        frameBorder="0"
                        allowFullScreen
                        title="help"
                    />
                    <p>
                        <a href="https://vimeo.com/233351622">Vannm&aring;lerbytte</a> from{' '}
                        <a href="https://vimeo.com/norkart">Norkart</a> on{' '}
                        <a href="https://vimeo.com">Vimeo</a>.
                    </p>
                </div>
                <div className="responsive-paragraf" id="rapportfil" ref={ref => {
                    this.$ref = ref;
                }}>
                    <h3>Import av rapportfil i Excel</h3>
                    <ol>
                        <li>Last ned filen</li>
                        <li>Åpne opp Excel</li>
                        <li>Velg datafanen</li>
                        <li>Velg så 'Fra tekst/CSV' og finn filen som du lastet ned fra "Vannmålerbytte"</li>
                    </ol>
                    <p  className="responsive-paragraf">
                        Når du har importert filen skal det se slik ut som på bilde under, så kan en fortsette å arbeide med filen i Excel
                    </p>

                    <img

                        src={process.env.PUBLIC_URL + '/images/ImportTilExcel.png'}
                        alt="Import til Excel"
                        width="90%"
                        height="80%"
                        
                    />
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/felles/Hjelp/hjelp.jsx